const pt = {
  'page-title': 'Bootcamps de Laboratória',
  'page-description': `
    Desenvolva novas habilidades e transforme sua vida profissional com nosso
    bootcamp de desenvolvimento web.
  `,
  'callout-text': 'Nossos bootcamps',
  'know-more': 'Saiba mais',
  'know-more-link': 'entra aqui',
  'next-bootcamps': 'Próximos <em>bootcamps:</em>',
  'title': 'Desenvolva novas habilidades e transforme sua vida profissional',
  'web-dev-title': '<em>Bootcamp</em> de desenvolvimento web',
  'web-dev-description': `
    Aprenda a construir aplicações web dinâmicas e adaptáveis ​​a diferentes
    dispositivos, utilizando uma linguagem moderna e versátil, como o
    JavaScript, com bibliotecas de React ou Angular.
  `,
  'data-title': `<em>Bootcamp</em> de Análises de dados`,
  'data-description': `
    Aprenda todos os passos de análise de dados, desde a limpeza e
    processamento dos dados até a criação de dashboards para apresentar os
    resultados da análise. Aprenda também a usar ferramentas de IA.
  `,
  'no-available-cohorts': 'No momento não há processo seletivo disponível.',
};

export default pt;
